export default {
    async isAvailableAsync() {
        return false;
    },
    startObserving() { },
    stopObserving() { },
};
//# sourceMappingURL=ExponentPedometer.web.js.map